export default [
    {
        "name": "Part 1 Club GCH Members豪廷會会员拉新",
        "sort": 0,
        "Jan": 0,
        "Feb": 0,
        "Mar": 0,
        "Apr": 0,
        "May": 0,
        "Jun": 0,
        "Jul": 0,
        "Aug": 0,
        "Sep": 0,
        "Oct": 0,
        "Nov": 0,
        "Dec": 0,
        "total": 0
    },
    {
        "name": "Rooms Nights-Actual实际客房间夜",
        "sort": 1,
        "Jan": 0,
        "Feb": 0,
        "Mar": 0,
        "Apr": 0,
        "May": 0,
        "Jun": 0,
        "Jul": 0,
        "Aug": 0,
        "Sep": 0,
        "Oct": 0,
        "Nov": 0,
        "Dec": 0,
        "total": 0
    },
    {
        "name": "F&B Covers-Actual实际餐饮人数",
        "sort": 2,
        "Jan": 0,
        "Feb": 0,
        "Mar": 0,
        "Apr": 0,
        "May": 0,
        "Jun": 0,
        "Jul": 0,
        "Aug": 0,
        "Sep": 0,
        "Oct": 0,
        "Nov": 0,
        "Dec": 0,
        "total": 0
    },
    {
        "name": "Rooms Nights-Budget预算客房间夜",
        "sort": 3,
        "Jan": 0,
        "Feb": 0,
        "Mar": 0,
        "Apr": 0,
        "May": 0,
        "Jun": 0,
        "Jul": 0,
        "Aug": 0,
        "Sep": 0,
        "Oct": 0,
        "Nov": 0,
        "Dec": 0,
        "total": 0
    },
    {
        "name": "F&B Covers-Budget预算餐饮人数",
        "sort": 4,
        "Jan": 0,
        "Feb": 0,
        "Mar": 0,
        "Apr": 0,
        "May": 0,
        "Jun": 0,
        "Jul": 0,
        "Aug": 0,
        "Sep": 0,
        "Oct": 0,
        "Nov": 0,
        "Dec": 0,
        "total": 0
    },
    {
        "name": "Rooms Members-Budget(Target)客房拉新目标",
        "sort": 5,
        "Jan": 0,
        "Feb": 0,
        "Mar": 0,
        "Apr": 0,
        "May": 0,
        "Jun": 0,
        "Jul": 0,
        "Aug": 0,
        "Sep": 0,
        "Oct": 0,
        "Nov": 0,
        "Dec": 0,
        "total": 0
    },
    {
        "name": "F&B Members-Budget(Target)餐饮拉新目标",
        "sort": 6,
        "Jan": 0,
        "Feb": 0,
        "Mar": 0,
        "Apr": 0,
        "May": 0,
        "Jun": 0,
        "Jul": 0,
        "Aug": 0,
        "Sep": 0,
        "Oct": 0,
        "Nov": 0,
        "Dec": 0,
        "total": 0
    },
    {
        "name": "Total Members-Budget(Target)会员拉新总目标",
        "sort": 7,
        "Jan": 0,
        "Feb": 0,
        "Mar": 0,
        "Apr": 0,
        "May": 0,
        "Jun": 0,
        "Jul": 0,
        "Aug": 0,
        "Sep": 0,
        "Oct": 0,
        "Nov": 0,
        "Dec": 0,
        "total": 0
    },
    {
        "name": "Total Members-Actual实际会员拉新总数",
        "sort": 8,
        "Jan": 0,
        "Feb": 0,
        "Mar": 0,
        "Apr": 0,
        "May": 0,
        "Jun": 0,
        "Jul": 0,
        "Aug": 0,
        "Sep": 0,
        "Oct": 0,
        "Nov": 0,
        "Dec": 0,
        "total": 0
    },
    {
        "name": "Target completion rate(%)会员拉新完成率",
        "sort": 9,
        "Jan": 0,
        "Feb": 0,
        "Mar": 0,
        "Apr": 0,
        "May": 0,
        "Jun": 0,
        "Jul": 0,
        "Aug": 0,
        "Sep": 0,
        "Oct": 0,
        "Nov": 0,
        "Dec": 0,
        "total": 0
    },
    {
        "name": "Part 2 Club GCH Revenue豪廷會产量",
        "sort": 10,
        "Jan": 0,
        "Feb": 0,
        "Mar": 0,
        "Apr": 0,
        "May": 0,
        "Jun": 0,
        "Jul": 0,
        "Aug": 0,
        "Sep": 0,
        "Oct": 0,
        "Nov": 0,
        "Dec": 0,
        "total": 0
    },
    {
        "name": "Walkin Revenue-ActualWalkin实际收入",
        "sort": 11,
        "Jan": 0,
        "Feb": 0,
        "Mar": 0,
        "Apr": 0,
        "May": 0,
        "Jun": 0,
        "Jul": 0,
        "Aug": 0,
        "Sep": 0,
        "Oct": 0,
        "Nov": 0,
        "Dec": 0,
        "total": 0
    },
    {
        "name": "F&B Revenue-Actual（Excluding Banquet Revenue）<br />餐饮实际收入（不含宴会收入）",
        "sort": 12,
        "Jan": 0,
        "Feb": 0,
        "Mar": 0,
        "Apr": 0,
        "May": 0,
        "Jun": 0,
        "Jul": 0,
        "Aug": 0,
        "Sep": 0,
        "Oct": 0,
        "Nov": 0,
        "Dec": 0,
        "total": 0
    },
    {
        "name": "Walkin Revenue-Budget Walkin预算收入",
        "sort": 13,
        "Jan": 0,
        "Feb": 0,
        "Mar": 0,
        "Apr": 0,
        "May": 0,
        "Jun": 0,
        "Jul": 0,
        "Aug": 0,
        "Sep": 0,
        "Oct": 0,
        "Nov": 0,
        "Dec": 0,
        "total": 0
    },
    {
        "name": "F&B Revenue-Budget（Excluding Banquet Revenue）<br/>餐饮预算收入（不含宴会收入）",
        "sort": 14,
        "Jan": 0,
        "Feb": 0,
        "Mar": 0,
        "Apr": 0,
        "May": 0,
        "Jun": 0,
        "Jul": 0,
        "Aug": 0,
        "Sep": 0,
        "Oct": 0,
        "Nov": 0,
        "Dec": 0,
        "total": 0
    },
    {
        "name": "Walkin Revenue-Budget(Target)Walkin收入目标",
        "sort": 15,
        "Jan": 0,
        "Feb": 0,
        "Mar": 0,
        "Apr": 0,
        "May": 0,
        "Jun": 0,
        "Jul": 0,
        "Aug": 0,
        "Sep": 0,
        "Oct": 0,
        "Nov": 0,
        "Dec": 0,
        "total": 0
    },
    {
        "name": "F&B Revenue-Budget(Target)餐饮收入目标",
        "sort": 16,
        "Jan": 0,
        "Feb": 0,
        "Mar": 0,
        "Apr": 0,
        "May": 0,
        "Jun": 0,
        "Jul": 0,
        "Aug": 0,
        "Sep": 0,
        "Oct": 0,
        "Nov": 0,
        "Dec": 0,
        "total": 0
    },
    {
        "name": "Total Revenue-Budget(Target)收入总目标",
        "sort": 17,
        "Jan": 0,
        "Feb": 0,
        "Mar": 0,
        "Apr": 0,
        "May": 0,
        "Jun": 0,
        "Jul": 0,
        "Aug": 0,
        "Sep": 0,
        "Oct": 0,
        "Nov": 0,
        "Dec": 0,
        "total": 0
    },
    {
        "name": "Total Revenue-Actual实际总收入",
        "sort": 18,
        "Jan": 0,
        "Feb": 0,
        "Mar": 0,
        "Apr": 0,
        "May": 0,
        "Jun": 0,
        "Jul": 0,
        "Aug": 0,
        "Sep": 0,
        "Oct": 0,
        "Nov": 0,
        "Dec": 0,
        "total": 0
    },
    {
        "name": "Target completion rate(%)收入完成率",
        "sort": 19,
        "Jan": 0,
        "Feb": 0,
        "Mar": 0,
        "Apr": 0,
        "May": 0,
        "Jun": 0,
        "Jul": 0,
        "Aug": 0,
        "Sep": 0,
        "Oct": 0,
        "Nov": 0,
        "Dec": 0,
        "total": 0
    }
]


// WEBPACK FOOTER //
// ./src/components/table/12/data.js